import { render, staticRenderFns } from "./UserConversionWizard.vue?vue&type=template&id=56c5be1e&scoped=true&"
import script from "./UserConversionWizard.vue?vue&type=script&lang=js&"
export * from "./UserConversionWizard.vue?vue&type=script&lang=js&"
import style0 from "./UserConversionWizard.vue?vue&type=style&index=0&id=56c5be1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5be1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c5be1e')) {
      api.createRecord('56c5be1e', component.options)
    } else {
      api.reload('56c5be1e', component.options)
    }
    module.hot.accept("./UserConversionWizard.vue?vue&type=template&id=56c5be1e&scoped=true&", function () {
      api.rerender('56c5be1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/UserWizard/UserConversionWizard.vue"
export default component.exports